import React from "react";

export const TriangleIcon = () => (<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0h24v24H0z" fill="none" />
  <path d="M1 21h22L12 2" />
</svg>);
